/** @format */

import React, { useEffect } from 'react';
import { Select, Spin } from 'antd';
import { useVendors } from '../hooks/useVendors';
import { GlobalVendor } from '../types';

interface GlobalVendorDropdownProps {
  value?: string;
  onChange?: (value: string, vendor: GlobalVendor | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * GlobalVendorDropdown Component
 * Dropdown for selecting global vendors
 */
export const GlobalVendorDropdown: React.FC<GlobalVendorDropdownProps> = ({
  value,
  onChange,
  placeholder = 'Select a global vendor',
  disabled = false,
}) => {
  const { vendors, loading, fetchVendors } = useVendors();

  useEffect(() => {
    fetchVendors();
  }, [fetchVendors]);

  const handleChange = (selectedValue: string) => {
    const selectedVendor = vendors.find((v) => v._id === selectedValue);
    onChange?.(selectedValue, selectedVendor);
  };

  return (
    <Spin spinning={loading}>
      <Select
        showSearch
        placeholder={placeholder}
        value={value || undefined}
        onChange={handleChange}
        disabled={disabled || loading}
        optionLabelProp='label'
        style={{ width: '100%' }}
        filterOption={(input, option) =>
          (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
        }
      >
        {vendors.map((vendor: GlobalVendor) => (
          <Select.Option
            key={vendor._id}
            value={vendor._id}
            label={vendor.globalName}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>{vendor.globalName}</span>
              
            </div>
          </Select.Option>
        ))}
      </Select>
    </Spin>
  );
};

export default GlobalVendorDropdown;
